import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  radioButtons: {
    flexDirection: "row",
  },
  inputLabel: {
    color: theme.palette.secondary.main,
    fontWeight: 700,
    fontSize: "0.75rem",
    marginBottom: theme.spacing(0.5),
  },
  removeButton: {
    color: theme.palette.error.main,
  },
}))

export default styles
